import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  Box,
  CircularProgress,
} from '@mui/material';

interface ProcessExecutionDialogProps {
  open: boolean;
  title: string;
}

const ProcessExecutionDialog: React.FC<ProcessExecutionDialogProps> = ({ open, title }) => {
  return (
    <Dialog open={open} aria-describedby="scenario-generation-progress" maxWidth="xs">
      <DialogTitle id="scenario-generation-progress">{title}</DialogTitle>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px' }}>
        <CircularProgress />
      </Box>
    </Dialog>
  );
};

export default ProcessExecutionDialog;

export function removeDuplicate(arr: any[], item, index) {
  if (arr.indexOf(item) != index) {
    return item + index.toString();
  }
  return item
}
